let PrimePoiApiRoot = process.env.VUE_APP_POI_API_ROOT;
let AtriumApiRoot = process.env.VUE_APP_AUTH_API;
let PhocusEnigmaApi = process.env.VUE_APP_PHOCUS_ENIGMA_API;
let UserApi = process.env.VUE_APP_USER_API;
let AtriumApi = process.env.VUE_APP_ATRIUM;
let NetworkApi = process.env.VUE_APP_NETWORK_API;
let SettingApi = process.env.VUE_APP_SETTING_API;

const PrimePoiApiPaths = {
  Login: "api/login/login/",
  //Login: "users/authenticateuser/",
  ChangePassword: "users/changepassword/",
  GroupIds: "group/ids/",
  PoiCollectionGroup: "poicollection/group/",
  PoiCollectionPoi: "poicollection/poi/",
  Photo: "photo/",
  Technician: "technician/",
  //Settings: "poiCollection/technician/",
  //Settings: "setting/technician/",
  JsError: "JsError/"
};

const TechnicianSubPaths = {
  Token: "token/"
};

let SharedMobileServicesApiRoot =
  process.env.VUE_APP_SHARED_MOBILE_SERVICES_ROOT;

const SharedMobileServicesApiPaths = {
  ForgotPasswordTechnician: UserApi + "/api/login/updatepassword"
};

const MakeAuthHeader = jwt => {
  return { Authorization: `bearer ${jwt}` };
};

export {
  PrimePoiApiRoot,
  PrimePoiApiPaths,
  TechnicianSubPaths,
  SharedMobileServicesApiRoot,
  SharedMobileServicesApiPaths,
  MakeAuthHeader,
  AtriumApiRoot,
  PhocusEnigmaApi,
  UserApi,
  AtriumApi,
  NetworkApi,
  SettingApi
};
